const getters = {
  theme: state => state.colortheme.theme,
  fontColor: state => state.colortheme.fontColor,
  iconColor: state => state.colortheme.iconColor,
  bannerColorStart: state => state.colortheme.bannerColorStart,
  bannerColorEnd: state => state.colortheme.bannerColorEnd,
  hasShowQuestionnaire: state => state.zhongshan.hasShowQuestionnaire,
  showQuestionnaire: state => state.zhongshan.showQuestionnaire
}

export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js